import React from 'react';
import {
    BrowserRouter as Router,
    Route, Link, Redirect, withRouter
} from 'react-router-dom';
import Header from './components/dashboard/Header';
import Footer from './components/dashboard/Footer';

// Dashboard
import Main from "./pages/dashboard/Home";

import './App.css';
import DeliveryHistory from "./pages/dashboard/DeliveryHistory";
import Account from "./pages/dashboard/Account";
import DeliveryDetails from "./pages/dashboard/DeliveryDetails";
import PaymentReceipt from "./pages/dashboard/PaymentReceipt";
import {getUserType} from "./helpers/authenticator";
import RidersHome from "./pages/dashboard/RidersHome";
import CourierHome from "./pages/dashboard/CourierHome";
import RequestDetails from "./pages/dashboard/RequestDetails";
import RiderDetailsPage from "./pages/dashboard/RiderDetails";
import AddRider from "./pages/dashboard/AddRider";
import {ToastContainer} from "react-toastify";

function Dashboard({route}) {
    return (
        <Router>
            <div>
                <Header/>
                <ToastContainer/>
                {showView(route.id)}
            </div>
            <Footer/>
        </Router>
    );
}

const showView = (route) => {
    switch (route) {
        case "deliveries":
            return <DeliveryHistory/>;
        case "account":
            return <Account/>;
        case "home":
            return homepageDecider();
        case "track":
            return <DeliveryDetails/>;
        case "payment":
            return <PaymentReceipt/>;
        case "requests":
            return <RequestDetails/>;
        case "rider":
            return <RiderDetailsPage/>;
        case "add-rider":
            return <AddRider/>;
        default:
            return <Main/>;
    }
};

const homepageDecider = () => {
    switch (getUserType()) {
        case "user":
            return <Main/>;
        case "rider":
            return <RidersHome/>;
        case "courier":
            return <CourierHome/>;
        default:
            return <Main/>;
    }

};


export default Dashboard;
